// extracted by mini-css-extract-plugin
module.exports = {"alert":"EmailValidationAlert_alert__3NJSX","message":"EmailValidationAlert_message__14E1j","verify-button":"EmailValidationAlert_verify-button__221xA"};